const Action = require("../../entities/Action");
const {Age}  = require("../Constants");
const ActionNames = require("../Names/ActionNames");

class Reserves extends Action {
    constructor(age){
        super(
            age,
            ActionNames.Reserves, 
            `Gain either ${Reserves.GetQuantity(age)} food or ${Reserves.GetQuantity(age)} resource.`,
            {
                playerStateAltering:
                (playerState) => {
                    //Do stuff
                }
            },
            {}
        )
    }

    static GetQuantity(age){
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return 2;
            case Age.Age2:
                return 3;
            case Age.Age3:
                return 4;
        }
    }
}

module.exports = Reserves;
